import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import OnboardingPage from './pages/OnboardingPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import NewDashboardPage from './pages/dashboard/NewDashboardPage';
import StaticQRCPage from './pages/qrc/StaticQRCPage';
import StaticAmountQRCPage from './pages/qrc/StaticAmountQRCPage';
import DynamicPaymentQRCPage from './pages/qrc/DynamicPaymentQRCPage';
import RequestToPayPage from './pages/RequestToPayPage';
import RTPListsPage from './pages/RTPListsPage';
import TransactionHistoryPage from './pages/TransactionHistoryPage';
import UpdateProfilePage from './pages/UpdateProfilePage';
import MerchantAssessmentPage from './pages/MerchantAssessmentPage';
import SupportTicketsPage from './pages/SupportTicketsPage';
import DisputesPage from './pages/DisputesPage';
import Footer from './components/layout/Footer';
import { AuthProvider } from './context/AuthContext';
export function App() {
  return <BrowserRouter data-id="element-0">
      <AuthProvider data-id="element-1">
        <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-2">
          <main className="flex-grow" data-id="element-3">
            <Routes data-id="element-4">
              <Route path="/" element={<LandingPage data-id="element-6" />} data-id="element-5" />
              <Route path="/onboarding" element={<OnboardingPage data-id="element-8" />} data-id="element-7" />
              <Route path="/login" element={<LoginPage data-id="element-10" />} data-id="element-9" />
              <Route path="/dashboard" element={<NewDashboardPage data-id="element-12" />} data-id="element-11" />
              <Route path="/qrc/static" element={<StaticQRCPage data-id="element-14" />} data-id="element-13" />
              <Route path="/qrc/static-amount" element={<StaticAmountQRCPage data-id="element-16" />} data-id="element-15" />
              <Route path="/qrc/dynamic" element={<DynamicPaymentQRCPage data-id="element-18" />} data-id="element-17" />
              <Route path="/request-to-pay" element={<RequestToPayPage data-id="element-20" />} data-id="element-19" />
              <Route path="/rtp-lists" element={<RTPListsPage data-id="element-22" />} data-id="element-21" />
              <Route path="/transaction-history" element={<TransactionHistoryPage data-id="element-24" />} data-id="element-23" />

              <Route path="/update-profile" element={<UpdateProfilePage data-id="element-26" />} data-id="element-25" />
              <Route path="/merchant-assessment" element={<MerchantAssessmentPage data-id="element-28" />} data-id="element-27" />
              <Route path="/disputes" element={<DisputesPage data-id="element-30" />} data-id="element-29" />
              <Route path="/support-tickets" element={<SupportTicketsPage data-id="element-32" />} data-id="element-31" />
            </Routes>
          </main>
          <Footer data-id="element-33" />
        </div>
      </AuthProvider>
    </BrowserRouter>;
}